/* eslint-disable no-restricted-syntax */
// above disable is for the for..of
import { useRouter } from 'next/router';
import { useMemo } from 'react';

/**
 * Enhance useLocation with psuedo state
 */

// this util will take all of the nextJS "hidden" parameters and treat them as router.state
// also returning only the visible parameters should someone access router.query to mimic v3 functionality
const splitStateAndQueryParams = (
  query: Record<string, any>,
  asPath: string,
) => {
  const searchParams = new URLSearchParams(asPath.split('?')?.[1]);
  const state: Record<string, any> = {};
  const visibleQuery: Record<string, any> = {};

  for (const queryKey of Object.keys(query)) {
    if (searchParams.has(queryKey)) {
      visibleQuery[queryKey] = query[queryKey];
    } else {
      state[queryKey] = query[queryKey];
    }
  }

  return { state, query: visibleQuery };
};

const useLocation = () => {
  const router = useRouter();

  return useMemo(() => {
    const searchIndex = router.asPath.lastIndexOf('?');

    return {
      key: '',
      hash: '',
      ...router,
      ...splitStateAndQueryParams(router.query, router.asPath),
      pathname: `${
        router.locale && router.locale !== 'en' ? `/${router.locale}` : ''
      }${router.asPath.split('?')[0]}`,
      search: searchIndex !== -1 ? router.asPath.substring(searchIndex) : '',
    };
  }, [router]);
};

export default useLocation;
